<template>
  <div class="this-page" v-if="load.result">
    <template>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>运费设置</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <template>
      <el-table :data="result" stripe style="width: 100%;margin-top:20px" :fit="true" size="small"  :height="tableHeight">
        <el-table-column prop="id" label="编号">
        </el-table-column>
        <el-table-column prop="name" label="设置项">
        </el-table-column>
        <el-table-column prop="value" label="当前运费值">
        </el-table-column>
        <el-table-column prop="type" label="操作"  >
          <template slot-scope="scope">
            <el-button size="small" icon="el-icon-edit" @click="updateFee(scope.row.id,scope.row.name,scope.row.value)" type="danger">修改</el-button>

          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 210 + 'px',
      load: {
        result: false
      },
      result:[],
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165 + 'px';  // 高

      })()
    };
    this.getStatistics()

  },
  methods: {
    getStatistics() {
      this.$fetch.post('Setting/getFeeSetting', {}, true).then(res => {
        this.load.result = true
        this.result = res
      })
    },
    updateFee(id,name,old){
      this.$prompt(name, '修改以下项目的运费值', {
        confirmButtonText: '确定修改',
        cancelButtonText: '取消',
        inputType: 'number',
        inputPlaceholder:old
      }).then(({ value }) => {
        this.$fetch.post('Setting/updateFee', {id:id,value:value}, true).then(res => {
          this.$message({
            type: 'success',
            message: '修改完成'
          });
         this.getStatistics()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消修改'
        });
      });
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 20px;
  background-color: #FFFFFF;

}
.count{
  padding:10px 0;
}
.count span{
  font-size: 30px;
  padding: 0 10px;
}
.timer{
  padding: 20px 0;
  padding-bottom: 0;
}
</style>
